// Auto generated file, do not manually modify!
// com.hotpads.zcalendar.client.enums.TourDuration

export enum TourDuration {
  MINUTES_15 = 'MINUTES_15',
  MINUTES_20 = 'MINUTES_20',
  MINUTES_30 = 'MINUTES_30',
  MINUTES_60 = 'MINUTES_60',
}

export const TourDuration_values = [
  TourDuration.MINUTES_15,
  TourDuration.MINUTES_20,
  TourDuration.MINUTES_30,
  TourDuration.MINUTES_60,
] as const;
